!function () {
  const selectors = {
    copy: '[data-countdown-copy]',
    timer: '[data-countdown-timer]',
    ended: '[data-countdown-ended]',
    days: '[data-countdown-days]',
    hours: '[data-countdown-hours]',
    minutes: '[data-countdown-minutes]',
    seconds: '[data-countdown-seconds]'
  };

  function zonedDateToUtc(year, month, day, hour, minute, timeZone) {
    const guess = new Date(Date.UTC(year, month - 1, day, hour || 0, minute || 0, 0));
    const asUtc = new Date(guess.toLocaleString('en-US', { timeZone: 'UTC' }));
    const asTimeZone = new Date(guess.toLocaleString('en-US', { timeZone: timeZone }));
    const offset = asUtc.getTime() - asTimeZone.getTime();
    return new Date(guess.getTime() + offset);
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function CountdownTimerHeader(el) {
    this.el = el;
    this.settings = theme.helpers.safelyParseJson(el.dataset.sectionSettings);

    if (!this.settings || !this.settings.endYear || !this.settings.endMonth || !this.settings.endDay) return;

    this.copyEl = el.querySelector(selectors.copy);
    this.timerEl = el.querySelector(selectors.timer);
    this.endedEl = el.querySelector(selectors.ended);
    this.daysEl = el.querySelector(selectors.days);
    this.hoursEl = el.querySelector(selectors.hours);
    this.minutesEl = el.querySelector(selectors.minutes);
    this.secondsEl = el.querySelector(selectors.seconds);

    this.targetDate = zonedDateToUtc(
      Number(this.settings.endYear),
      Number(this.settings.endMonth),
      Number(this.settings.endDay),
      Number(this.settings.endHour),
      Number(this.settings.endMinute),
      this.settings.timeZone || 'Australia/Sydney'
    );

    this.render = this.render.bind(this);
    this.render();
    this.intervalId = setInterval(this.render, 1000);
  }

  CountdownTimerHeader.prototype = Object.assign({}, CountdownTimerHeader.prototype, {
    render: function () {
      const remainingMs = this.targetDate.getTime() - Date.now();

      if (remainingMs <= 0) {
        clearInterval(this.intervalId);
        if (this.copyEl) this.copyEl.hidden = true;
        if (this.timerEl) this.timerEl.hidden = true;
        if (this.endedEl) this.endedEl.hidden = false;
        return;
      }

      const totalSeconds = Math.floor(remainingMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = pad(days);
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    },
    onUnload: function () {
      clearInterval(this.intervalId);
    }
  });

  window.theme = window.theme || {};
  window.theme.sections = window.theme.sections || new theme.Sections();
  window.theme.CountdownTimerHeader = CountdownTimerHeader;
  theme.sections.register('countdown-timer-header', theme.CountdownTimerHeader);
}();
